import React, { createContext, useState, useContext, ReactNode } from 'react';


interface CustomerContextType {
    customerData: any | null;
  setCustomerData: React.Dispatch<React.SetStateAction<any | null>>;
}

const CustomerContext = createContext<CustomerContextType>({
    customerData: null,
    setCustomerData: () => {}
});

interface CustomerProviderProps {
  children: ReactNode;
}

export const CustomerProvider: React.FC<CustomerProviderProps> = ({ children }) => {
  const [customerData, setCustomerData] = useState<any | null>(null);

  return (
    <CustomerContext.Provider value={{ customerData, setCustomerData }}>
      {children}
    </CustomerContext.Provider>
  );
};

export const useCustomer = (): CustomerContextType => {
  const context = useContext(CustomerContext);
  if (context === undefined) {
    throw new Error('useCustomer must be used within a CustomerProvider');
  }
  return context;
};
